<template>
  <el-dialog
    title="事项管理"
    :visible.sync="dialogVisible"
    width="680px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form :model="formInline" ref="form" label-width="140px">
        <el-form-item label="事项类型">
          <el-select
            style="width: 356px;"
            v-model="formInline.ghEventTypeId"
            placeholder="请选择"
            @change="handleChange"
            disabled
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.sxlx"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事项名称">
          <el-input
            style="width: 356px;"
            v-model="formInline.sxmc"
            placeholder="事项名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="state">
          <el-switch
            v-model="formInline.state"
            active-value="是"
            inactive-value="否"
            active-color="#0495FF"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="主办部门">
          <!-- :disabled="curItem.editType === 'edit'" -->
          <el-select
            style="width: 356px;"
            v-model="formInline.tjDeptId"
            placeholder="请选择"
            @change="useRuleTableFun"
            :disabled="curItem.superFlag === 'EVENT_TYPE_TYPE_INFINITE' || curItem.editType === 'add' ? false : true"
          >
            <el-option
              v-for="item in deptList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="数据源类型">
          <el-radio-group v-model="dataRadio" @change="dataRadioChange">
            <el-radio label="1">使用数据源</el-radio>
            <el-radio label="2">导入数据源</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item
          label="使用数据源"
          v-if="curItem.superFlag == 'EVENT_TYPE_TYPE_FRC' && dataRadio == 1"
        >
          <el-select
            style="width: 356px;"
            v-model="formInline.extendGzUseRuleTable"
            placeholder="请选择"
          >
            <el-option
              v-for="item in useRuleList"
              :key="item.useRuleTable"
              :label="`${item.useRuleTable} (总数${item.trueCount})`"
              :value="item.useRuleTable"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          label="数据源文件"
          v-if="curItem.superFlag == 'EVENT_TYPE_TYPE_FRC' && dataRadio == 2"
        >
          <el-upload
            class="upload-demo"
            accept=".xlsx"
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="importDataFun"
          >
            <el-button class="other el-icon-upload2">数据导入</el-button>
          </el-upload>
        </el-form-item> -->
        <el-form-item
          label="社区每日完成次数"
          v-if="curItem.superFlag == 'EVENT_TYPE_TYPE_INFINITE'"
        >
          <el-input
            style="width: 356px;"
            v-model="formInline.dayTimes"
            placeholder="社区每日完成次数"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="科室每周完成次数"
          v-if="curItem.superFlag == 'EVENT_TYPE_TYPE_INFINITE'"
        >
          <el-input
            style="width: 356px;"
            v-model="formInline.ksWeekTimes"
            placeholder="科室每周完成次数"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="时间范围"
          v-if="curItem.superFlag == 'EVENT_TYPE_TYPE_INFINITE'"
        >
          <div v-for="(item, index) in extendTimeRangeList" :key="index">
            <el-time-picker
              style="width: 240px;margin-bottom: 12px;"
              is-range
              :key="index"
              v-model="item.time"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
            >
            </el-time-picker>
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="addExtendTime"
            >
              新增
            </el-button>
            <el-button
              v-if="index != 0"
              type="danger"
              icon="el-icon-delete"
              @click="extendTimeRangeList.splice(index, 1)"
            >
              删除
            </el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="事项任务目标经度"
          v-if="curItem.superFlag == 'EVENT_TYPE_TYPE_INFINITE'"
        >
          <el-input
            style="width: 356px;"
            v-model="formInline.extendLongitude"
            placeholder="事项任务目标经度"
          >
            <template slot="append">°E</template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="事项任务目标纬度"
          v-if="curItem.superFlag == 'EVENT_TYPE_TYPE_INFINITE'"
        >
          <div style="display:flex;">
            <el-input
              style="width: 356px;"
              v-model="formInline.extendLatitude"
              placeholder="事项任务目标纬度"
            >
              <template slot="append">°N</template>
            </el-input>
            <el-button
              @click="mapVisible = true"
              type="text"
              style="margin-left: 16px;"
              >地图定位</el-button
            >
          </div>
        </el-form-item>
        <el-form-item
          label="事项任务详细地址"
          v-if="curItem.superFlag == 'EVENT_TYPE_TYPE_INFINITE'"
        >
          <el-input
            style="width: 356px;"
            v-model="formInline.extendAddress"
            placeholder="事项任务详细地址"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="打卡距目标要求"
          v-if="curItem.superFlag == 'EVENT_TYPE_TYPE_INFINITE'"
        >
          <el-input
            style="width: 356px;"
            v-model="formInline.extendRangeMetre"
            placeholder="打卡距目标要求"
            type="number"
          >
            <span slot="append">米</span>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="eventEditFun">确 定</el-button>
    </span>
    <mapSearch
      @cancel="mapVisible = false"
      @map-confirm="confirmLocation"
      :visible="mapVisible"
    ></mapSearch>
  </el-dialog>
</template>
<script>
import { dictItemRoot, getDeptTree } from "@/api/systemManagement.js";
import { eventEdit, importExtendClRk, useRuleTable } from "@/api/base.js";
import mapSearch from "@/components/map-search/index.vue";
import moment from "moment";
export default {
  components: { mapSearch },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    },

    typeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      dataRadio: "1",
      mapVisible: false,
      formInline: {
        ghEventTypeId: "",
        state: "",
        sxmc: "",
        zrrlx: "街道人员",
        id: "",
        tjDeptId: "",
        extendGzUseRuleTable: "",
        dayTimes: "",
        ksWeekTimes: "",
        extendRangeMetre: null,
        extendLongitude: null,
        extendLatitude: null,
        extendAddress: null
      },
      // zrrlxOptions: [],
      extendTimeRangeList: [
        {
          time: null
        }
      ],
      deptList: [],
      useRuleList: [],
      curSource: {
        text: "",
        value: ""
      }
    };
  },
  created() {
    this.formInline = JSON.parse(JSON.stringify(this.curItem));
    this.handleChange(this.formInline.ghEventTypeId);
  },
  mounted() {
    this.formatDate();
    this.getTree();
    this.useRuleTableFun();
  },
  methods: {
    dataRadioChange() {
      this.formInline.extendGzUseRuleTable = "";
    },
    // 数据导入
    async importDataFun(file) {
      if (!file.name.endsWith(".xlsx")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.xlsx",
          type: "warning"
        });
        return;
      }
      if (!this.formInline.tjDeptId) {
        this.$message({
          message: "请选择主办部门",
          type: "warning"
        });
        return;
      }
      if (!this.formInline.sxmc) {
        this.$message({
          message: "请输入事项名称",
          type: "warning"
        });
        return;
      }
      let deptId =
        JSON.parse(sessionStorage.getItem("userInfo")) &&
        JSON.parse(sessionStorage.getItem("userInfo")).deptId;
      let formData = new FormData();
      formData.append("file", file.raw);
      formData.append("ruleTable", this.formInline.sxmc);
      formData.append("zbDeptId", this.formInline.tjDeptId || deptId);
      const res = await importExtendClRk(formData);
      if (res.data.code == 200) {
        this.$message({
          message: "导入成功",
          type: "success"
        });
        this.formInline.extendGzUseRuleTable = res.data.data.useRuleTable;
        this.useRuleTableFun();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    handleChange(value) {
      let curInfo = this.typeList.find(item => item.id == value);
      if (curInfo.superFlagName == "非日常巡查上报") {
        this.curSource.text = "非日常巡查上报";
        this.curSource.value = "EVENT_TYPE_TYPE_FRC";
      } else {
        this.curSource.text = "";
        this.curSource.value = "";
      }
    },
    confirmLocation(e) {
      this.lnglat = e;
      this.formInline.extendLongitude = e.lng;
      this.formInline.extendLatitude = e.lat;
      this.formInline.extendAddress = e.addr;
      this.mapVisible = false;
    },
    formatDate() {
      if (this.formInline.extendTimeRangeList) {
        this.extendTimeRangeList = [];
        let timeRanges = this.formInline.extendTimeRangeList.split(",");

        timeRanges.forEach(item => {
          let [startTime, endTime] = item.split("-");
          let [startHour, startMinute, startSecond] = startTime.split(":");
          let [endHour, endMinute, endSecond] = endTime.split(":");

          this.extendTimeRangeList.push({
            time: [
              new Date(
                2016,
                9,
                21,
                Number(startHour),
                Number(startMinute),
                Number(startSecond)
              ),
              new Date(
                2016,
                9,
                21,
                Number(endHour),
                Number(endMinute),
                Number(endSecond)
              )
            ]
          });
        });

        console.log("Parsed time range:", this.extendTimeRangeList);
      }
    },
    addExtendTime() {
      this.extendTimeRangeList.push({
        time: null
      });
    },
    // 获取部门资源树形
    async getTree() {
      let params = {
        page: 999,
        size: 1,
        pid: "2000000035",
        data: true
      };
      const res = await getDeptTree(params);
      if (res.data.code == 200) {
        this.deptList = res.data.data;
      }
    },
    // 获取部门资源树形
    async useRuleTableFun(value) {
      console.log(value);

      let deptId =
        JSON.parse(sessionStorage.getItem("userInfo")) &&
        JSON.parse(sessionStorage.getItem("userInfo")).deptId;
      let params = {
        deptId: this.formInline.tjDeptId || deptId
      };
      if (value) this.formInline.extendGzUseRuleTable = "";
      const res = await useRuleTable(params);
      if (res.data.code == 200) {
        this.useRuleList = res.data.data;
      }
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async dictItemRootFun() {
      const { data } = await dictItemRoot({
        dictType: "GH_ZRRLX",
        data: true,
        pid: -1,
        page: 1,
        size: 9999
      });
      this.zrrlxOptions = data.data.dataList || [];
    },
    async eventEditFun(submitFlag) {
      let params = {
        ghEventTypeId: this.formInline.ghEventTypeId,
        state: this.formInline.state,
        sxmc: this.formInline.sxmc,
        zrrlx: this.formInline.zrrlx,
        id: this.formInline.id,
        tjDeptId: this.formInline.tjDeptId,
        extendGzUseRuleTable: this.formInline.extendGzUseRuleTable,
        dayTimes: this.formInline.dayTimes,
        ksWeekTimes: this.formInline.ksWeekTimes
      };
      if (this.formInline.superFlag == "EVENT_TYPE_TYPE_INFINITE") {
        let extendTimeRangeList = [];
        if (this.extendTimeRangeList.length) {
          this.extendTimeRangeList.forEach(item => {
            if (item.time && item.time.length) {
              extendTimeRangeList.push(
                moment(item.time[0]).format("HH:mm:ss") +
                  "-" +
                  moment(item.time[1]).format("HH:mm:ss")
              );
            }
          });
        }
        params.extendLongitude = this.formInline.extendLongitude;
        params.extendLatitude = this.formInline.extendLatitude;
        params.extendAddress = this.formInline.extendAddress;
        params.extendRangeMetre = this.formInline.extendRangeMetre;
        params.extendTimeRangeList = extendTimeRangeList.toString();
      }
      const res = await eventEdit(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-input {
  width: 340px !important;
}
/deep/.el-upload__input {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/baseInfo/issuesManagement/components/issuesDialog.vue